import { inject, injectable } from "inversify";
import { SERVICE_TYPES } from "setup/dependency/ServiceTypes";
import { ClientPortalCookiePreferencesModel, ICPLAuthClientPortalCookiesClient } from "./api/cplauthapi/CPLAuthAPI";
import Cookies from "js-cookie";

export interface IClientPortalCookieService {
  updateCookiePreferences(): Promise<void>;
  getLocalCookiePreferences(): ClientPortalCookiePreferencesModel | null;
  setLocalCookiePreferences(cookiePreferences: ClientPortalCookiePreferencesModel): void;
}

@injectable()
export class ClientPortalCookieService implements IClientPortalCookieService {
  @inject(SERVICE_TYPES.CPLAuthClientPortalCookiesClient)
  cplClientPortalCookiesClient!: ICPLAuthClientPortalCookiesClient;
  readonly cplCookiePreferencesKey = "cpl_cookie_preferences";

  async updateCookiePreferences(): Promise<void> {
    const localCookiePreferences = this.getLocalCookiePreferences();
    if (localCookiePreferences == null) return;

    await this.cplClientPortalCookiesClient.updateCookiePreferences(localCookiePreferences);
  }

  getLocalCookiePreferences(): ClientPortalCookiePreferencesModel | null {
    const cookieValue = Cookies.get(this.cplCookiePreferencesKey);
    if (cookieValue == null) {
      return null;
    }

    return JSON.parse(cookieValue);
  }

  setLocalCookiePreferences(cookiePreferences: ClientPortalCookiePreferencesModel) {
    cookiePreferences.dateUpdated = new Date();
    cookiePreferences.userAgent = navigator.userAgent;
    const cookieValue = JSON.stringify(cookiePreferences);
    Cookies.set(this.cplCookiePreferencesKey, cookieValue, {
      expires: 183, // Half a year (Recommended) - 365 is the legal maximum, do not increase above that
      secure: true,
      path: "",
    });
  }
}
